//import jwt_decode from "jwt-decode";

export default {
    getErrors 						: state => state.errors,
    getNotif 						: state => state.notif,
    getNotifMsg						: state => state.notif_msg,
    getNotifType					: state => state.notif_type
}